import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import GridTitleCard from "../Cards/GridTitleCard";
import { faClock } from "@fortawesome/pro-solid-svg-icons";
import WorkerTimeRecordGrid from "./WorkerTimeRecordGrid";
import WorkerTimeRecordSidePanel from "./WorkerTimeRecordSidePanel";

interface WorkerTimeRecordPageProps extends RouteComponentProps {
    title: string;
    category: string;
    location: any;
}

interface WorkerTimeRecordPageState {
    workerTimeRecordTypeId: string;
    workerTimeRecordStatusId: string;
}

class WorkerTimeRecordPage extends Component<WorkerTimeRecordPageProps> {
    state: WorkerTimeRecordPageState;

    constructor(props: WorkerTimeRecordPageProps) {
        super(props);
        this.state = {
            workerTimeRecordTypeId: "",
            workerTimeRecordStatusId: ""
        };
    }

    /**
     * Applies worker time record filters for grid reload.
     */
    onApplyButtonClick = (workerTimeRecordTypeId: string, workerTimeRecordStatusId: string) => {
        this.setState({
            workerTimeRecordTypeId,
            workerTimeRecordStatusId
        });
    };

    /**
     * Resolves the service type for route and hard-refresh scenarios.
     */
    getServiceTypeId = () => {
        if (this.props.location && this.props.location.state && this.props.location.state.serviceType) {
            return this.props.location.state.serviceType;
        }

        return sessionStorage.getItem("serviceTypeFilter") || "";
    };

    render() {
        return (
            <LightModePageTemplate>
                <SideBarTemplate isFixedDesktopOnly={true}>
                    <WorkerTimeRecordSidePanel
                        onApplyButtonClick={this.onApplyButtonClick}
                    />
                    <BulletinPanel />
                </SideBarTemplate>
                <div className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mt-3 mb-3">
                        <GridTitleCard title="Worker Time Record Details" icon={faClock} cardStyle="admin" />
                    </header>
                    <div className="row">
                        <div className="col-md">
                            <WorkerTimeRecordGrid
                                workerTimeRecordTypeId={this.state.workerTimeRecordTypeId}
                                workerTimeRecordStatusId={this.state.workerTimeRecordStatusId}
                            />
                        </div>
                        <div></div>
                    </div>
                </div>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(WorkerTimeRecordPage);
